module.exports = __webpack_public_path__ + "static/media/21ECLAC1.d54fe5d4.jpg";